import React, { useState } from "react";
import {
  Divider,
  makeStyles,
  Typography,
  Checkbox,
  IconButton,
  CircularProgress,
} from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import moment from "moment";

import Table from "../../components/Table";
import { Card, CardContent, CardActions } from "../../components/Card";
import { Select, TextInput } from "../../components/Form";
import Grid from "../../components/Grid";
import TransferDialog from "./TransferDialog";
import RedoIcon from "@material-ui/icons/Redo";
import { propertyDataArray } from "../../components/PropertyDataArray";
import { useAlert } from "../../components/Alert";

const GET_CUSTOMERCENTERS = gql`
  query customers(
    $searchTerm: String
    $customerType: CustomerType
    $customerSource: CustomerSource
    $missed: Boolean
    $latest: Boolean
    $pageSize: Int
    $page: Int
  ) {
    customers(
      searchTerm: $searchTerm
      customerType: $customerType
      customerSource: $customerSource
      missed: $missed
      latest: $latest
      pageSize: $pageSize
      page: $page
    ) {
      count
      pageCount
      contents {
        id
        customerType
        source
        customerStatus
        customerInfo {
          id
          fullName
          mobile1
          mobile2
          email
        }
        createdAt
      }
    }
  }
`;

export default function MissCustomerTable({ onChangeSelect = () => {} }) {
  const Alert = useAlert();
  const { customerAttributesAllArray, customerSourceAllArray } =
    propertyDataArray();
  const [newData, setNewData] = useState({
    open: false,
    id: [],
    franchiseStoreArray: [],
    franchiseStoreObject: {},
    salespersonArray: [],
    salespersonObject: {},
    customerTypeObject: {
      label: "全部",
      value: null,
    },
    customerSourceObject: {
      label: "全部",
      value: null,
    },
    searchTerm: "",
    page: 1,
    pageMax: null,
    pageSize: 10,
    pageArray: [],
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }

  const {
    data,
    refetch,
    loading: loading,
  } = useQuery(GET_CUSTOMERCENTERS, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      searchTerm: newData.searchTerm,
      customerType: newData.customerTypeObject.value,
      customerSource: newData.customerSourceObject.value,
      missed: true,
      latest: true,
      pageSize: 10,
      page: newData.page,
    },
    onError(error) {
      return Alert.notice(`${error}`);
    },
  });
  if (loading) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={6} sm={2}>
              <Typography color="primary" style={{ fontSize: 15 }}>
                客戶屬性
              </Typography>
              <Select
                items={customerAttributesAllArray}
                value={newData.customerTypeObject}
                onChange={(e, value) => {
                  if (value) changeData("customerTypeObject", value, true);
                  else changeData("customerTypeObject", {}, true);
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sm={2}>
              <Typography color="primary" style={{ fontSize: 15 }}>
                客戶來源
              </Typography>
              <Select
                items={customerSourceAllArray}
                value={newData.customerSourceObject}
                onChange={(e, value) => {
                  if (value) changeData("customerSourceObject", value, true);
                  else changeData("customerSourceObject", {}, true);
                }}
                fullWidth
              />
            </Grid>
            {/* <Grid item xs={6} sm={2}>
              <Typography color="primary" style={{ fontSize: 15 }}>
                客戶狀態
              </Typography>
              <Select
                items={newData.clientStatusArray}
                value={newData.clientStatusObject}
                onChange={(e, value) => {
                  if (value) changeData("clientStatusObject", value, true);
                  else changeData("clientStatusObject", {}, true);
                }}
                fullWidth
              />
            </Grid> */}
            <Grid item xs={6} sm={2}>
              <Typography color="primary" style={{ fontSize: 15 }}>
                關鍵字
              </Typography>
              <TextInput
                value={newData.searchTerm}
                onChange={(v) => {
                  changeData("searchTerm", v, true);
                }}
                fullWidth
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardContent>
          <Table
            data={data?.customers.contents}
            tableWidth={3}
            header={[
              "客戶屬性",
              "客戶來源",
              "姓名",
              "聯絡電話",
              "E-mail",
              "追蹤紀錄",
              "追蹤日期",
              "建檔日期",
              "操作",
            ]}
            columns={[
              (item) =>
                customerAttributesAllArray.find(
                  (item2) => item2.value === item.customerType
                ).label,
              (item) =>
                customerSourceAllArray.find(
                  (item2) => item2.value === item.source
                ).label,
              (item) =>
                item.customerInfo.map((item2) => {
                  return item2.fullName + "\n";
                }),
              (item) =>
                item.customerInfo.map((item2) => {
                  return `${item2.mobile1 + "\n"}${
                    item2.mobile2 ? item2.mobile2 + "\n" : "\n"
                  }`;
                }),
              (item) =>
                item.customerInfo.map((item2) => {
                  return `${item2.email ? item2.email + "\n" : "\n"}`;
                }),
              "record",
              "date",
              (item) => moment(item.createdAt).format("yyyy/MM/DD"),
              (item) => (
                <IconButton
                  onClick={(event) => {
                    event.stopPropagation();
                    changeData("id", [item.id]);
                    changeData("open", true, true);
                  }}
                >
                  <RedoIcon />
                </IconButton>
              ),
            ]}
            onPress={(item) => {
              onChangeSelect(item);
            }}
          />
          <TransferDialog
            open={newData.open}
            id={newData.id}
            onClose={(v) => {
              if (v === "refetch") refetch();
              changeData("open", false, true);
            }}
          />
        </CardContent>
        <CardActions>
          <Grid container justifyContent="center">
            <Pagination
              count={
                Boolean(data) && data.customers.pageCount
                  ? data.customers.pageCount
                  : 1
              }
              size="large"
              color="primary"
              page={newData.page}
              onChange={(e, n) => {
                changeData("page", n, true);
              }}
            />
          </Grid>
        </CardActions>
      </Card>
    );
  }
}
